import axiosInstance from './axiosInstance';

export const userLogin = (username, password) =>
    axiosInstance.post("/User/UserLogin", { username, password });

export const isUserAuthenticated = () =>
    axiosInstance.get("/User/isUserAuthenticated");

// Self-service password reset — backed by AuthController.
// requestPasswordReset always returns { ok: true } regardless of whether the
// email exists (anti-enumeration). resetPassword validates the one-time token
// from the emailed link and updates the user's password.
export const requestPasswordReset = (email) =>
    axiosInstance.post("/Auth/ForgotPassword", { email });

export const resetPassword = (token, newPassword) =>
    axiosInstance.post("/Auth/ResetPassword", { token, newPassword });

export const getAllAgents = () =>
    axiosInstance.get("/User/GetAllAgents");

export const getAllAgentGroups = () =>
    axiosInstance.get("/User/GetAllAgentGroups");

export const getAgentDetailsByAgentId = (agentId) =>
    axiosInstance.get(`/User/GetAgentDetailsById?agentId=${agentId}`);

export const getAgentsByGroupId = (groupId) =>
    axiosInstance.get(`/User/GetAgentsByGroupId?groupId=${groupId}`);

export const updateUserPassword = (userId, currentPassword, newPassword) =>
    axiosInstance.put("/User/UpdateUserPassword", { userId, currentPassword, newPassword });

export const createUser = (request) =>
    axiosInstance.post("/User/CreateUser", request);

export const updateUser = (request) =>
    axiosInstance.put("/User/UpdateUser", request);

export const adminResetPassword = (userId, newPassword) =>
    axiosInstance.put("/User/AdminResetPassword", { userId, newPassword });

export const impersonateUser = (targetUserId) =>
    axiosInstance.post(`/User/Impersonate?targetUserId=${targetUserId}`);

export const getCommissionHistory = (userId) =>
    axiosInstance.get(`/User/GetCommissionHistory?userId=${userId}`);

export const updateProfile = (request) =>
    axiosInstance.put("/User/UpdateProfile", request);

export const uploadProfilePhoto = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post("/User/UploadProfilePhoto", formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const setUserProcessingFee = (userId, enabled) =>
    axiosInstance.put("/User/SetProcessingFee", { userId, enabled });
